import { FileText, Check, Shield } from "lucide-react";

export default function StepTerms({ accepted, setAccepted }) {
  return (
    <div data-testid="step-terms">
      <h2 className="crm-heading mb-2">Termos de Serviço</h2>
      <p className="text-sm mb-8" style={{ color: "var(--crm-text-muted)" }}>
        O cliente deve ler e aceitar os termos para prosseguir com a venda.
      </p>

      <div className="crm-card overflow-hidden max-w-2xl">
        {/* Header */}
        <div className="px-6 py-4 flex items-center gap-3" style={{ borderBottom: "1px solid var(--crm-border)", background: "var(--crm-input-bg)" }}>
          <Shield className="w-5 h-5" style={{ color: "var(--crm-accent)" }} />
          <h3 className="text-base font-bold" style={{ color: "var(--crm-text)" }}>Termos e Condições — NewSky Mobile</h3>
        </div>

        {/* Terms content */}
        <div className="px-6 py-5 max-h-[350px] overflow-y-auto text-[14px] leading-7 space-y-5" style={{ color: "var(--crm-text-secondary)" }}>
          <div>
            <p className="font-bold mb-1" style={{ color: "var(--crm-text)" }}>1. Serviços</p>
            <p>A NewSky Mobile fornece serviços de telecomunicação móvel no Japão, incluindo planos de dados e voz com chip físico (SIM) ou eSIM.</p>
          </div>
          <div>
            <p className="font-bold mb-1" style={{ color: "var(--crm-text)" }}>2. Ativação</p>
            <p>O serviço será ativado após a confirmação do pagamento e verificação dos documentos necessários. O prazo de ativação pode variar de acordo com o tipo de chip escolhido.</p>
          </div>
          <div>
            <p className="font-bold mb-1" style={{ color: "var(--crm-text)" }}>3. Pagamento</p>
            <p>Os pagamentos devem ser realizados mensalmente até a data de vencimento. Métodos aceitos: cartão de crédito, transferência bancária, ou pagamento em konbini.</p>
          </div>
          <div>
            <p className="font-bold mb-1" style={{ color: "var(--crm-text)" }}>4. Cancelamento</p>
            <p>O cliente pode cancelar o serviço a qualquer momento sem multa. O cancelamento será efetivado ao final do período já pago.</p>
          </div>
          <div>
            <p className="font-bold mb-1" style={{ color: "var(--crm-text)" }}>5. Uso Aceitável</p>
            <p>O serviço deve ser utilizado de acordo com as leis japonesas. O uso indevido pode resultar na suspensão do serviço.</p>
          </div>
          <div>
            <p className="font-bold mb-1" style={{ color: "var(--crm-text)" }}>6. Proteção de Dados</p>
            <p>Os dados pessoais do cliente são protegidos de acordo com a Lei de Proteção de Informações Pessoais do Japão (APPI).</p>
          </div>
          <div>
            <p className="font-bold mb-1" style={{ color: "var(--crm-text)" }}>7. Suporte</p>
            <p>O suporte é oferecido em português, espanhol e inglês, de segunda a sexta das 10:00 às 19:00 e sábados das 10:00 às 13:00.</p>
          </div>
        </div>

        {/* Acceptance */}
        <div className="px-6 py-5" style={{ borderTop: "2px solid var(--crm-border)" }}>
          <label
            className="flex items-center gap-4 cursor-pointer p-4 rounded-xl transition-all"
            style={{
              background: accepted ? "rgba(16,185,129,0.06)" : "var(--crm-input-bg)",
              border: `2px solid ${accepted ? "rgba(16,185,129,0.4)" : "var(--crm-border)"}`,
            }}
          >
            <input type="checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)}
              data-testid="wizard-terms-checkbox" className="w-6 h-6 rounded accent-orange-500 flex-shrink-0" />
            <div>
              <p className="text-sm font-bold" style={{ color: accepted ? "#10b981" : "var(--crm-text)" }}>
                {accepted ? (
                  <span className="flex items-center gap-1.5"><Check className="w-4 h-4" /> Termos aceitos pelo cliente</span>
                ) : (
                  "Li e o cliente aceita os Termos de Serviço"
                )}
              </p>
              <p className="text-xs mt-0.5" style={{ color: "var(--crm-text-muted)" }}>
                Obrigatório para prosseguir com a venda
              </p>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}
